import React, { useState } from "react";
import { MapPin, Phone, Mail, Globe, Clock } from "lucide-react";
import { toast } from "sonner";
import { BRAND } from "../lib/brand";

const MAP_SRC =
  "https://www.google.com/maps?q=" +
  encodeURIComponent("Hradecká 2152/35, 621 00 Brno-Řečkovice") +
  "&z=15&output=embed";

export default function Kontakt() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });

  const submit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Vyplňte prosím všechna pole.");
      return;
    }
    const body = encodeURIComponent(`Jméno: ${form.name}\nE-mail: ${form.email}\n\n${form.message}`);
    window.location.href = `mailto:${BRAND.email}?subject=Dotaz z webu KAME&body=${body}`;
    toast.success("Otevírám váš e-mailový klient…");
  };

  return (
    <div className="bg-black" data-testid="kontakt-page">
      <section className="container-kame pt-14 pb-10">
        <p className="eyebrow">Jsme tu pro vás</p>
        <h1 className="font-display text-4xl sm:text-5xl text-white uppercase mt-2">Kontakt</h1>
        <div className="w-16 h-1 bg-[#B58A50] mt-5" />
      </section>

      <section className="container-kame pb-16 grid lg:grid-cols-2 gap-10">
        <div className="space-y-4">
          <div className="card-kame p-6 flex items-start gap-4">
            <span className="w-11 h-11 rounded-sm bg-[#B58A50]/15 flex items-center justify-center text-[#B58A50] shrink-0"><MapPin size={22} /></span>
            <div className="min-w-0">
              <p className="eyebrow mb-1">Adresa</p>
              <p className="text-white">{BRAND.address.street}</p>
              <p className="text-white/70 text-sm">{BRAND.address.city} {BRAND.address.part}</p>
            </div>
          </div>

          <div className="card-kame p-6 flex items-start gap-4">
            <span className="w-11 h-11 rounded-sm bg-[#B58A50]/15 flex items-center justify-center text-[#B58A50] shrink-0"><Phone size={22} /></span>
            <div className="min-w-0">
              <p className="eyebrow mb-1">Telefon</p>
              {BRAND.phones.map((p) => (
                <a key={p} href={`tel:${p.replace(/\s/g, "")}`} className="block text-white hover:text-[#B58A50]">{p}</a>
              ))}
            </div>
          </div>

          <div className="grid sm:grid-cols-2 gap-4">
            <div className="card-kame p-6 flex items-start gap-4">
              <span className="w-11 h-11 rounded-sm bg-[#B58A50]/15 flex items-center justify-center text-[#B58A50] shrink-0"><Mail size={22} /></span>
              <div className="min-w-0">
                <p className="eyebrow mb-1">E-mail</p>
                <a href={`mailto:${BRAND.email}`} className="text-white text-sm break-words hover:text-[#B58A50]">{BRAND.email}</a>
              </div>
            </div>
            <div className="card-kame p-6 flex items-start gap-4">
              <span className="w-11 h-11 rounded-sm bg-[#B58A50]/15 flex items-center justify-center text-[#B58A50] shrink-0"><Globe size={22} /></span>
              <div className="min-w-0">
                <p className="eyebrow mb-1">Web</p>
                <p className="text-white text-sm break-words">{BRAND.web}</p>
              </div>
            </div>
          </div>

          <div className="card-kame p-6 flex items-start gap-4">
            <span className="w-11 h-11 rounded-sm bg-[#B58A50]/15 flex items-center justify-center text-[#B58A50] shrink-0"><Clock size={22} /></span>
            <div className="w-full">
              <p className="eyebrow mb-2">Otevírací doba</p>
              {BRAND.hours.map((h) => (
                <div key={h.days} className="flex justify-between text-sm border-b border-[#141414] py-1.5">
                  <span className="text-white/70">{h.days}</span>
                  <span className="text-white">{h.time}</span>
                </div>
              ))}
              <p className="text-white/45 text-xs mt-2">Mimo pracovní dobu po předchozí telefonické domluvě kdykoliv.</p>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-6">
          <div className="card-kame overflow-hidden h-[340px]">
            <iframe
              title="Mapa KAME Autopůjčovna"
              src={MAP_SRC}
              className="w-full h-full grayscale-[0.3]"
              style={{ border: 0 }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              data-testid="contact-map"
            />
          </div>

          <form onSubmit={submit} className="card-kame p-6 space-y-4" data-testid="contact-form">
            <h3 className="font-display text-xl text-white uppercase">Napište nám</h3>
            <input
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              placeholder="Jméno a příjmení"
              className="w-full bg-[#151515] border border-[#1f1f1f] text-white rounded-sm px-4 py-3 text-sm focus:border-[#B58A50] outline-none"
              data-testid="contact-name"
            />
            <input
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              placeholder="Váš e-mail"
              className="w-full bg-[#151515] border border-[#1f1f1f] text-white rounded-sm px-4 py-3 text-sm focus:border-[#B58A50] outline-none"
              data-testid="contact-email"
            />
            <textarea
              value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
              placeholder="Vaše zpráva"
              rows={4}
              className="w-full bg-[#151515] border border-[#1f1f1f] text-white rounded-sm px-4 py-3 text-sm focus:border-[#B58A50] outline-none resize-none"
              data-testid="contact-message"
            />
            <button type="submit" className="btn-gold w-full justify-center" data-testid="contact-submit">
              Odeslat zprávu
            </button>
          </form>
        </div>
      </section>
    </div>
  );
}
